import React from 'react';
import Layout from "../components/Layout";
import NavOne from "../components/NavOne";
import PageHeader from "../components/PageHeader";
import Footer from "../components/Footer";
import TqjDetails from "../components/TqjDetails";

const TqjDetailsPage = () => {
    return (
        <Layout pageTitle="苏州卫捷 | 贴签设备">
            <NavOne />
            <PageHeader title="分拣设备" />
            <TqjDetails />
            <Footer />
        </Layout>
    );
};

export default TqjDetailsPage;
